import React, { Fragment, useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import DataTable from "react-data-table-component";
import user3 from "../../assets/images/user/1.jpg";
import { Button, Input, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Breadcrumbs } from "../../AbstractElements";
import { useSelector } from "react-redux";
import apiRequest from "../../utils/apiRequest";

const AllCustomers = () => {
  const [supportData, setSupportData] = useState([]);
  const [filter, setFilter] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [blockUserModal, setBlockUserModal] = useState(false);
  const [userToBlock, setUserToBlock] = useState(null);
  const token = useSelector((state) => state.auth.userToken);

  const fetchData = async (page) => {
    try {
      setLoading(true);
    
      const response = await apiRequest('get', `${process.env.REACT_APP_API_BASE_URL}/admin/active-users`, {}, token);

      setSupportData(response.data.totalActiveUsers);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data: ", error);
      setLoading(false);
    }
  };

  const handleShowModal = (user) => {
    setSelectedUser(user);
    setModalOpen(true);
  };

  const toggleBlockUserModal = (user) => {
    setUserToBlock(user);
    setBlockUserModal(!blockUserModal);
  };

  const confirmBlockUser = async () => {
    try {
      await apiRequest('patch', `${process.env.REACT_APP_API_BASE_URL}/admin/block-user/${userToBlock._id}`, {}, token);
      // Optionally, you can refresh the data after blocking the user
      fetchData(currentPage);
      setBlockUserModal(false);
    } catch (error) {
      console.error("Error blocking user: ", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const customColumns = [
    {
      name: "Profile Picture",
      cell: (row) => (
        <div className="social-img-wrap">
          <div>
            <img
              className="img-60 m-0 rounded-circle"
              src={row.profileImage || user3}
              alt="User"
              style={{ width: "100px" }}
            />
          </div>
        </div>
      ),
      center: false,
    },
    {
      name: "User Name",
      selector: (row) => row["userName"],
      sortable: true,
      center: false,
    },
    {
      name: "Email",
      selector: (row) => row["email"],
      sortable: true,
      center: false,
      minWidth: "200px",
      maxWidth: "300px",
    },
    {
      name: "Location",
      selector: (row) => row["location"],
      sortable: true,
      center: false,
    },
    {
      name: "Block User",
      cell: (row) => (
        <Button
          color="danger"
          
          onClick={() => toggleBlockUserModal(row)}
        >
          Block
        </Button>
      ),
      button: true,
      center: true,
      minWidth: "200px",
      maxWidth: "300px",
    },
  ];

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleToggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const history = useNavigate();
  const handleViewDetails = (user) => {
    history(`/user-details/${user._id}`);
  };

  return (
    <Fragment>
      <style>
        {`
          .primary-table-header tbody tr:first-of-type td {
            border-top: none;
          }
          .dt-table > .card {
            border: none;
          }
          .dt-table > .card > .card-body {
            padding-top: 0;
          }
        `}
      </style>
      <Breadcrumbs
        mainTitle="All Customers"
        parent="Dashboard"
        title="All Customers"
        subtitle="List of all customers"
      />
      <div className="container-fluid">
        <div className="row">
          {/* <div className="col-12 mb-3">
            <Input
              type="text"
              placeholder="Search by user name..."
              value={searchTerm}
              onChange={handleSearch}
              style={{ marginLeft: "10px", width: "250px" }}
            />
          </div> */}
          <div className="col-12">
            <DataTable
              columns={customColumns}
              data={supportData}
              pagination
              paginationServer
              paginationTotalRows={totalPages * 10}
              paginationPerPage={10}
              paginationDefaultPage={currentPage}
              onChangePage={(page) => setCurrentPage(page)}
              responsive
              striped
              highlightOnHover
              customStyles={{
                rows: {
                  style: {
                    minHeight: "72px",
                  },
                },
                headCells: {
                  style: {
                    paddingLeft: "8px",
                    paddingRight: "8px",
                  },
                },
                cells: {
                  style: {
                    paddingLeft: "8px",
                    paddingRight: "8px",
                  },
                },
              }}
              progressPending={loading}
            />
          </div>
        </div>
      </div>
      <Modal isOpen={modalOpen} toggle={handleToggleModal}>
        <ModalBody>
          <h5>User Details</h5>
          {selectedUser && (
            <div>
              <p>
                <strong>User Name:</strong> {selectedUser.userName}
              </p>
              <p>
                <strong>Email:</strong> {selectedUser.email}
              </p>
              <p>
                <strong>Phone Number:</strong> {selectedUser.phoneNumber}
              </p>
              <p>
                <strong>Guest:</strong> {selectedUser.isGuest ? "Yes" : "No"}
              </p>
              <p>
                <strong>Subscription:</strong>{" "}
                {selectedUser.subscription ? "Yes" : "No"}
              </p>
            </div>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={handleToggleModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={blockUserModal} toggle={toggleBlockUserModal}>
        <ModalHeader toggle={toggleBlockUserModal}>Confirm Block</ModalHeader>
        <ModalBody>
          Are you sure you want to block the user titled "
          {userToBlock?.userName}"?
        </ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmBlockUser}>
            Block
          </Button>{" "}
          <Button color="secondary" onClick={toggleBlockUserModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
};

export default AllCustomers;
